import * as React from 'react';
import { FAIR_PLAY_LINK } from './constants';
import { OnlyForFairPlayersWrapper } from '../OnlyForFairPlayersWrapper';
import { LinkButton } from '../../../../../common/LinkButton';

interface IOnlyForFairPlayersProps {
  onClickFairPlayButton(): void;
}

export const OnlyForFairPlayersInitial = ({ onClickFairPlayButton }: IOnlyForFairPlayersProps) => {
  return (
    <OnlyForFairPlayersWrapper>
      <span>
        Услуга доступна только участникам программы
        <br />
        <a href={FAIR_PLAY_LINK} target="_blank">
          «Работаю честно»
        </a>
      </span>

      <LinkButton marginTop={12} onClick={onClickFairPlayButton}>
        Принять участие
      </LinkButton>
    </OnlyForFairPlayersWrapper>
  );
};
